import CekKeluarMasukTradoArsipMain from "../../features/cek-keluar-masuk/cek-keluar-masuk-trado/cek-keluar-masuk-trado-arsip/component/CekKeluarMasukTradoArsipMain";

const CekKeluarMasukTradoArsipPage = () => {
  return <CekKeluarMasukTradoArsipMain />;
};

export default CekKeluarMasukTradoArsipPage;
